import { createReducer } from 'src/helpers/reducer';
import actionTypes from './actionTypes';
import type { IRateCardReviewState, IRateCardValidation } from '../types';

const initState: IRateCardReviewState = {
  publishing: false,
  publishErrors: [],
  publishConflict: false,
  publishedId: null,
  validation: null,
  validationLoading: false,
  validationError: false,
};

export default createReducer(initState, {
  [actionTypes.PUBLISH_REQUEST]: (state: IRateCardReviewState): IRateCardReviewState => ({
    ...state,
    publishing: true,
    publishErrors: [],
    publishConflict: false,
    publishedId: null,
  }),

  [actionTypes.PUBLISH_SUCCESS]: (
    state: IRateCardReviewState,
    { payload }: { payload: { cardId: string } },
  ): IRateCardReviewState => ({
    ...state,
    publishing: false,
    publishedId: payload.cardId,
  }),

  [actionTypes.PUBLISH_ERROR]: (
    state: IRateCardReviewState,
    { payload }: { payload: { errors: string[]; conflict?: boolean } },
  ): IRateCardReviewState => ({
    ...state,
    publishing: false,
    publishErrors: payload.errors,
    publishConflict: Boolean(payload.conflict),
  }),

  // Stepping back to the re-import panels drops the publish banners, but not the pre-check: the same
  // findings still apply, and re-arming Confirm on the way forward would need another request.
  [actionTypes.CLEAR_PUBLISH_STATE]: (state: IRateCardReviewState): IRateCardReviewState => ({
    ...state,
    publishing: false,
    publishErrors: [],
    publishConflict: false,
    publishedId: null,
  }),

  // The previous answer is kept while the next is fetched: blanking it would drop the blockers off the
  // screen and put a skeleton in their place. The page reads a re-check as unanswered regardless.
  [actionTypes.LOAD_VALIDATION_REQUEST]: (state: IRateCardReviewState): IRateCardReviewState => ({
    ...state,
    validationLoading: true,
    validationError: false,
  }),

  [actionTypes.LOAD_VALIDATION_SUCCESS]: (
    state: IRateCardReviewState,
    { payload }: { payload: IRateCardValidation },
  ): IRateCardReviewState => ({
    ...state,
    validationLoading: false,
    validationError: false,
    validation: payload,
  }),

  // `validation` is dropped: a stale answer beside a failure notice would be read as the current one.
  [actionTypes.LOAD_VALIDATION_ERROR]: (state: IRateCardReviewState): IRateCardReviewState => ({
    ...state,
    validationLoading: false,
    validationError: true,
    validation: null,
  }),

  [actionTypes.CLEAR_STORE]: () => initState,
});
